import {
  type BentoBoxCardAlignX,
  type BentoBoxCardAlignY,
  type BentoBoxCardContentWidthPercentage,
} from "@root/tablescape/state/bentoBox";
import { type TTailwindString, tw } from "classnames";

export const baseStyles = {
  base: ({
    alignX,
    alignY,
    className,
  }: {
    alignX: BentoBoxCardAlignX;
    alignY: BentoBoxCardAlignY;
    className?: TTailwindString;
  }) =>
    tw(
      "flex",
      "p-4",
      "md:p-6",
      {
        [tw("justify-center")]: alignX === "center",
      },
      {
        [tw("items-center")]: alignY === "center",
        [tw("items-end")]: alignY === "bottom",
      },
      "rounded-lg",
      "h-full",
      "w-full",
      "gap-x-4",
      "box-border",
      "overflow-hidden",
      "relative",
      className ? tw(className) : undefined
    ),
  content: ({
    alignX,
    contentWidthPercentage,
  }: {
    alignX: BentoBoxCardAlignX;
    contentWidthPercentage: BentoBoxCardContentWidthPercentage;
  }) =>
    tw(
      {
        [tw(`w-1/2`)]: contentWidthPercentage === "50",
        [tw(`w-3/4`)]: contentWidthPercentage === "75",
        [tw(`w-full`)]: contentWidthPercentage === "100",
      },
      {
        [tw("text-center")]: alignX === "center",
      },
      "relative",
      "flex",
      "flex-col"
    ),
};
